/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlIntegrationEntitlementWarningV2
 */
export interface ControlIntegrationEntitlementWarningV2 {
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationEntitlementWarningV2
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationEntitlementWarningV2
     */
    when: boolean;
}

/**
 * Check if a given object implements the ControlIntegrationEntitlementWarningV2 interface.
 */
export function instanceOfControlIntegrationEntitlementWarningV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "when" in value;

    return isInstance;
}

export function ControlIntegrationEntitlementWarningV2FromJSON(json: any): ControlIntegrationEntitlementWarningV2 {
    return ControlIntegrationEntitlementWarningV2FromJSONTyped(json, false);
}

export function ControlIntegrationEntitlementWarningV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationEntitlementWarningV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'when': json['when'],
    };
}

export function ControlIntegrationEntitlementWarningV2ToJSON(value?: ControlIntegrationEntitlementWarningV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'when': value.when,
    };
}

